import BaseFormPresenter from "../../../../base/BaseFormPresenter";
import {
  findObjectUseCase,
  saveObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";

class QAComparisonRVRPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  componentDidMount() {
    this.init();
    this.getObject();
    this.getAnswer();
    // this.getObjectQA();
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.view.getParams().formId;
    console.log("formId", id);
    if (id) {
      const params = {
        include: ["categories", "categories.questions"],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async getAnswer() {
    const collectionMIS = "rvr_forms_answer_mis";
    const collectionQA = "rvr_forms_answer_qa";
    const id = this.view.getParams().id;
    if (id) {
      const params = {
        include: ["form", "answers", "answers.answer"],
      };
      try {
        this.view.showProgress();
        const agentAnswer = await this.getObjectUseCase.execute(
          collectionMIS,
          id,
          {
            params,
          }
        );
        const qaAnswer = await this.getObjectUseCase.execute(collectionQA, id, {
          params,
        });
        this.view.hideProgress();
        console.log("ANSWER AGENT", agentAnswer);
        console.log("ANSWER QA", qaAnswer);
        this.view.setAgentAnswer(agentAnswer);
        this.view.setQaAnswer(qaAnswer);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async getObjectQA() {
    const collection = "employment_verification_form_qa";
    const id = this.view.getParams().id;
    console.log("ID", id);
    if (id) {
      const params = {
        include: [
          "text",
          "categories",
          "categories.text",
          "categories.text.answers",
          "categories.text.answers.answer",
          "upload",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.view.setQAObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async onClickStatus(status) {
    const url = this.view.getParams();
    const user = this.view.getCurrentUser();

    const parts = url["*"].split("/");
    const secondPart = parts[1];
    const indexPart = parts[2];
    const query = {
      where: {
        id: secondPart,
      },
    };
    const getEndorsementById = await findObjectUseCase().execute(
      "endorsement",
      query
    );

    const object = getEndorsementById[indexPart];

    object.statusQA = status;

    if (status === "Approved") {
      const queryUser = {
        where: {
          name: object.agent,
        },
      };
      const findAgent = await findObjectUseCase().execute("users", queryUser);
      const findAgentIndex = findAgent[0];

      const dateTimeSubmitted = new Date(object.dateTimeSubmitted);
      const timeCompleted = this.convertToDateTime(
        object.timeCompleted,
        dateTimeSubmitted
      );
      // console.log("dts", dateTimeSubmitted, "tc", timeCompleted);

      // if (dateTimeSubmitted < timeCompleted) {
      //   findAgentIndex.rank = (findAgentIndex.rank || 0) + 1; // Add points, initialize if undefined
      // } else {
      //   findAgentIndex.rank = (findAgentIndex.rank || 0) + 0.5; // Add points, initialize if undefined
      // }
      if (dateTimeSubmitted < timeCompleted) {
        // findAgentIndex.rank = (findAgentIndex.rank || 0) + 1; // Add points, initialize if undefined
        findAgentIndex.countPoints = findAgentIndex.countPoints || [];
        findAgentIndex.countPoints.push({
          countPoint: 1,
          countEndorserment: 1,
          // createdAt: currentDate,
        });
        // findAgentIndex.countPoints =
        //   (findAgentIndex.numberEndorsement || 0) + 1;
      } else {
        findAgentIndex.countPoints = findAgentIndex.countPoints || 0; // Add points, initialize if undefined
        findAgentIndex.countPoints.push({
          countPoint: 0.5,
          countEndorserment: 1,
          // createdAt: currentDate,
        });
      }
      // console.log("findAgent", findAgent);
      await upsertUseCase().execute("users", findAgentIndex);
    }

    object.reason = this.view.state.reason || "";

    await upsertUseCase().execute("endorsement", object);
    // this.view.submissionSuccess();
    // this.view.showSuccessSnackbar("Successfully saved!");
    this.view.navigateBack();
  }

  convertToDateTime(timeCompleted, referenceDate) {
    const { hour, minute, period } = timeCompleted;

    let hours = parseInt(hour, 10);
    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    const completedDate = new Date(referenceDate);
    completedDate.setHours(hours);
    completedDate.setMinutes(parseInt(minute, 10));
    completedDate.setSeconds(0);
    completedDate.setMilliseconds(0);

    return completedDate;
  }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   const collectionEndorsement = "endorsement";
  //   const collectionUsers = "users";
  //   const currentDate = new Date().toISOString();
  //   const object = this.view.state.object;
  //   console.log("OBJECT SEND", object);
  //   const url = this.view.getParams();

  //   const parts = url["*"].split("/");
  //   console.log("parts", parts);
  //   const secondPart = parts[1];
  //   const indexPart = parts[2];
  //   const query = {
  //     where: {
  //       id: secondPart,
  //     },
  //   };
  //   const queryUser = {
  //     sort: {
  //       createdAt: 1,
  //     },
  //     include: ["All", "roles.name", "location.name"],
  //   };
  //   const users = await findObjectUseCase().execute("users", queryUser);

  //   // Filter users with the role QA
  //   const qaUsers = users.filter((user) =>
  //     user.roles.some((role) => role.name === "QA")
  //   );

  //   // Sort MISUsers by createdAt to establish initial order
  //   qaUsers.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  //   const sortedQAUsers = qaUsers.sort((a, b) => {
  //     const aEndorsementCount = a.endorsement ? a.endorsement.length : 0;
  //     const bEndorsementCount = b.endorsement ? b.endorsement.length : 0;
  //     console.log("aE", aEndorsementCount);
  //     console.log("bE", bEndorsementCount);
  //     const check = aEndorsementCount === bEndorsementCount ? true : false;
  //     console.log("check", check);

  //     if (aEndorsementCount === bEndorsementCount) {
  //       return new Date(a.createdAt) - new Date(b.createdAt);
  //     }
  //     const minus = aEndorsementCount - bEndorsementCount;
  //     console.log("minus", minus);
  //     return minus;
  //   });

  //   // Select the user with the fewest endorsements, or the earliest created if counts are equal
  //   const userForQA = sortedQAUsers[0];
  //   console.log("Next user for QA:", userForQA);

  //   const findEndorsement = await findObjectUseCase().execute(
  //     collectionEndorsement,
  //     query
  //   );

  //   let endorsementQA = findEndorsement[indexPart];

  //   console.log("findEndorsement", endorsementQA);

  //   let options = {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: false,
  //     timeZone: "Asia/Manila",
  //   };
  //   const formatter = new Intl.DateTimeFormat("en-GB", options);
  //   let partss = formatter.formatToParts(new Date());
  //   const timeString = `${partss.find((p) => p.type === "year").value}-${
  //     partss.find((p) => p.type === "month").value
  //   }-${partss.find((p) => p.type === "day").value} ${
  //     partss.find((p) => p.type === "hour").value
  //   }:${partss.find((p) => p.type === "minute").value}:${
  //     partss.find((p) => p.type === "second").value
  //   }`;

  //   // endorsementQA.status = "For QA";
  //   // endorsementQA.statusQA = "Pending";
  //   // endorsementQA.createdBy = userForQA.id;
  //   // endorsementQA.timeline = endorsementQA?.timeline || [];
  //   // endorsementQA.timeline?.push({
  //   //   time: timeString,
  //   //   status: "For QA",
  //   // });
  //   // userForQA.endorsement = userForQA.endorsement || [];
  //   // userForQA.endorsement.push({
  //   //   id: secondPart,
  //   //   createdAt: currentDate,
  //   // });

  //   try {
  //     await this.upsertUseCase.execute(collection, object);
  //     await this.upsertUseCase.execute(collectionEndorsement, endorsementQA);
  //     //   await this.upsertUseCase.execute(collectionUsers, userForQA);
  //     this.change = {};
  //   } catch (error) {
  //     throw error; // rethrow the error to be caught by the caller
  //   }
  // }

  async save() {
    const collectionEndorsement = "endorsement";
    const object = this.view.state.object;
    const url = this.view.getParams();
    const parts = url["*"].split("/");
    console.log("parts", parts);
    const secondPart = parts[1];
    const indexPart = parts[2];
    const query = {
      where: {
        id: secondPart,
      },
    };

    const findEndorsement = await findObjectUseCase().execute(
      collectionEndorsement,
      query
    );

    let endorsementQA = findEndorsement[indexPart];

    if ("Approved" === "Approved") {
      const queryUser = {
        where: {
          name: endorsementQA.agent,
        },
      };
      const findAgent = await findObjectUseCase().execute("users", queryUser);
      const findAgentIndex = findAgent[0];

      const dateTimeSubmitted = new Date(object.dateTimeSubmitted);
      const timeCompleted = this.convertToDateTime(
        endorsementQA.timeCompleted,
        dateTimeSubmitted
      );

      if (dateTimeSubmitted < timeCompleted) {
        // findAgentIndex.rank = (findAgentIndex.rank || 0) + 1; // Add points, initialize if undefined
        findAgentIndex.countPoints = findAgentIndex.countPoints || [];
        findAgentIndex.countPoints.push({
          countPoint: 1,
          countEndorserment: 1,
          // createdAt: currentDate,
        });
        // findAgentIndex.countPoints =
        //   (findAgentIndex.numberEndorsement || 0) + 1;
      } else {
        findAgentIndex.countPoints = findAgentIndex.countPoints || 0; // Add points, initialize if undefined
        findAgentIndex.countPoints.push({
          countPoint: 0.5,
          countEndorserment: 1,
          // createdAt: currentDate,
        });
      }
      console.log("findAgent", findAgentIndex);
      await upsertUseCase().execute("users", findAgentIndex);
    }

    endorsementQA.statusQA = "Approved";

    console.log("BVR_QA : ", object);
    console.log("Collection Endorsement : ", endorsementQA);

    try {
      await saveObjectUseCase().execute(
        "employment_verification_form_qa",
        object
      );
      await this.upsertUseCase.execute(collectionEndorsement, endorsementQA);
      //   await this.upsertUseCase.execute(collectionUsers, userForQA);
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }

  async submit() {
    // if (Object.values(this.change).length === 0) {
    //   this.view.showSuccessSnackbar("Successfully saved!");
    //   return;
    // }
    try {
      this.view.submitting();
      await this.save();
      this.view.submissionSuccess();
      this.view.showSuccessSnackbar("Successfully saved!");
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }

  // async save() {
  //   const collection = this.view.getCollectionName();
  //   const user = this.view.getCurrentUser();
  //   const currentDate = new Date().toISOString();
  //   const query = {
  //     sort: {
  //       createdAt: 1,
  //     },
  //     include: ["All", "roles.name", "location.name"],
  //   };

  //   if (this.object.id) {
  //     this.change.id = this.object.id;
  //   }

  //   try {
  //     // Fetch all users
  //     const users = await findObjectUseCase().execute("users", query);
  //     console.log("All users fetched:", users);

  //     // Filter users with the role MIS
  //     const MISUsers = users.filter((user) =>
  //       user.roles.some((role) => role.name === "MIS")
  //     );

  //     // Sort MISUsers by createdAt to establish initial order
  //     MISUsers.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  //     console.log("establish", MISUsers);

  //     // Sort users by the number of endorsements, then by createdAt if endorsements are equal
  //     const sortedMISUsers = MISUsers.sort((a, b) => {
  //       const aEndorsementCount = a.endorsement ? a.endorsement.length : 0;
  //       const bEndorsementCount = b.endorsement ? b.endorsement.length : 0;
  //       console.log("aE", aEndorsementCount);
  //       console.log("bE", bEndorsementCount);
  //       const check = aEndorsementCount === bEndorsementCount ? true : false;
  //       console.log("check", check);

  //       if (aEndorsementCount === bEndorsementCount) {
  //         return new Date(a.createdAt) - new Date(b.createdAt);
  //       }
  //       const minus = aEndorsementCount - bEndorsementCount;
  //       console.log("minus", minus);
  //       return minus;
  //     });
  //     console.log("sorted[0]", sortedMISUsers);
  //     console.log("sorted[0]", sortedMISUsers[0]);

  //     // Select the user with the fewest endorsements, or the earliest created if counts are equal
  //     const userForEndorsement = sortedMISUsers[0];
  //     console.log("Next user for endorsement:", userForEndorsement);

  //     // Process the endorsement
  //     this.change.createdBy = userForEndorsement.id;
  //     this.change.status = "For Dispatch";
  //     this.change.clientName = user.name;
  //     this.change.borrowerName = this.change.residentName;
  //     this.change.rType = this.view.state.selectedForm.label;
  //     const responseEndorse = await this.upsertUseCase.execute(
  //       collection,
  //       this.change
  //     );
  //     console.log("Endorsement response:", responseEndorse);

  //     // Update the endorsement array for the user
  //     userForEndorsement.endorsement = userForEndorsement.endorsement || [];
  //     userForEndorsement.endorsement.push({
  //       id: responseEndorse.id,
  //       createdAt: currentDate,
  //     });

  //     // Save the updated user
  //     await this.upsertUseCase.execute("users", userForEndorsement);

  //     this.change = {};
  //   } catch (error) {
  //     console.error("Error in save function:", error);
  //     throw error; // Rethrow the error to be caught by the caller
  //   }
  // }
}

export default QAComparisonRVRPresenter;
